import dayjs from "dayjs";

/**
 * 判断字符串是否为8位纯数字
 * @param str 待检测的字符串
 * @returns 如果是8位纯数字返回 true，否则返回 false
 */
export const isEightDigits: (str: string) => boolean = (str) => {
  return /^\d{8}$/.test(str);
};

/**
 * 将8位日期字符串转换为时间戳
 * @param str 8位日期字符串，格式为 YYYYMMDD，如 "20260309"
 * @returns 时间戳（毫秒），无效字符串返回 0
 */
export const strToTime: (str: string) => number = (str) => {
  if (!str || str.length !== 8 || !isEightDigits(str)) {
    return 0;
  }
  const date = dayjs(str, "YYYYMMDD");
  return date.isValid() ? date.endOf('day').valueOf() : 0;
};